import React from 'react';
import {connect} from 'react-redux';

import { FormGroup } from 'reactstrap';

import find from 'lodash/find';
import isEqual from 'lodash/isEqual';

import { formatPrice } from '../../utils/content';

import Select from '../forms/Select';


function getAttributeValueArticleValue(articles, mapper = a => a) {
  return (attributeId, attributeValueId) => {
    const article = find(articles, a => (
      a.attributeValueIds[attributeId] &&
      a.attributeValueIds[attributeId] === attributeValueId
    ));
    // Archived variants leave attribute values with no active article; guard
    // against the missing article so the lookup never throws.
    return article ? mapper(article) : '';
  }
}

// Attribute value IDs that map to an existing (active) article. Values from
// archived variants are absent here, so they are shown but disabled.
function getAvailableAttributeValueIds(articles) {
  const ids = {};
  articles.forEach((article) => {
    Object.keys(article.attributeValueIds).forEach((attributeId) => {
      ids[article.attributeValueIds[attributeId]] = true;
    });
  });
  return ids;
}

const ProductDetailSingleAttribute = connect(state => {
  return {
    // showArticleNumber: state.auth.isSignedIn
    showArticleNumber: true
  }
})(({id: attributeId, name, values, selectedValueId, availableValueIds, getAttributeValuePrice, getAttributeValueArticleNumber, showArticleNumber = false, onChange}) => {

  return (
    <FormGroup key={`product-attrbute-${attributeId}`}>
      <Select
        options={values.map(({id: attributeValueId, name}) => {
          const isAvailable = !availableValueIds || availableValueIds[attributeValueId];
          return {
            label: isAvailable
              ? `${name}, ${formatPrice(getAttributeValuePrice(attributeId, attributeValueId), 'kr')} ${showArticleNumber ? `(${getAttributeValueArticleNumber(attributeId, attributeValueId)})` : ''}`
              : `${name} (ej tillgänglig)`,
            value: attributeValueId,
            isDisabled: !isAvailable
          };
        })}
        value={selectedValueId}
        placeholder={name}
        onChange={(option) => onChange(attributeId, option.value)}
        searchable={false}
        clearable={false}
        selectedValueLabel={name}
      />
    </FormGroup>
  )
})


const ProductDetailAttribute = ({id, name, values, selectedValueId, availableValueIds, articles, onChange}) => {

  return (
    <FormGroup key={`product-attrbute-${id}`}>
      <Select
        options={values.map(({id, name}) => {
          const isAvailable = !availableValueIds || availableValueIds[id];
          return {
            label: isAvailable ? name : `${name} (ej tillgänglig)`,
            value: id,
            isDisabled: !isAvailable
          };
        })}
        value={selectedValueId}
        placeholder={name}
        onChange={(option) => onChange(id, option.value)}
        searchable={false}
        clearable={false}
        selectedValueLabel={name}
      />
    </FormGroup>
  )
}

const ProductDetailAttributeColor = ({id: attributeId, name, values, selectedValueId, onChange}) => {

  const valueIdIsSelected = (valueId) => valueId === selectedValueId;

  const colorStyle = ({color}, isSelected) => ({
    display: "inline-block",
    verticalAlign: "middle",
    width: "30px",
    height: "30px",
    lineHeight: "27px",
    backgroundColor: color,
    color: color,
    borderRadius: "50%",
    marginRight: ".25em",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: (isSelected ? "rgba(0, 0, 0, .8)" : "transparent"),
    textAlign: "center",
  });

  const hiddenInputStyle = {
    visibility: "hidden",
    position: "absolute",
  }

  return (
    <FormGroup key={`product-attrbute-${attributeId}`}>
      <div>
        {values.map(({id: valueId, name, data}) => (
          <label key={valueId} style={{marginRight: "1em"}}>
            <input type="radio" checked={valueIdIsSelected(valueId)} onChange={onChange.bind(null, attributeId, valueId)} style={hiddenInputStyle}/>
            <span style={colorStyle(data, valueIdIsSelected(valueId))}>
              {
                valueIdIsSelected(valueId) &&
                <i className="fa fa-check" style={{color: "rgba(0, 0, 0, .8)"}}/>
              }
            </span>
            <span>{name}</span>
          </label>
        ))}
      </div>
    </FormGroup>
  ) 

}


const ProductDetailAttributeFactory = (props) => {

  const {valueType, numOfAttributes} = props;

  switch(valueType) {
    // case 'color':
    //   return <ProductDetailAttributeColor {...props}/>;
    default:
      return (
        numOfAttributes === 1 ? 
          <ProductDetailSingleAttribute {...props}/> : 
          <ProductDetailAttribute {...props}/>
      )
  }
}

class ProductDetailAttributes extends React.PureComponent {

  render() {
    const {attributes, article, articles, onChange} = this.props;

    // Values with no active article (e.g. left behind by archived variants) are
    // still shown but rendered disabled, so the choice stays visible.
    const availableValueIds = getAvailableAttributeValueIds(articles);
    const selectableAttributes = attributes.filter(a => a.values.length > 1);

    return (
      <div>
        {selectableAttributes.map((attribute) => (
          <ProductDetailAttributeFactory
            key={attribute.id}
            {...attribute}
            availableValueIds={availableValueIds}
            getAttributeValuePrice={getAttributeValueArticleValue(articles, article => article.price.default)}
            getAttributeValueArticleNumber={getAttributeValueArticleValue(articles, article => article.articleNumber)}
            numOfAttributes={selectableAttributes.length}
            selectedValueId={article.attributeValueIds[attribute.id]}
            onChange={onChange}
          />
        ))}
      </div>
    )
  }
}


export default ProductDetailAttributes;